// extracted by css-extract-rspack-plugin
export default {"author":"TimelineAuthor-module__author__U2D0P","avatar":"TimelineAuthor-module__avatar__qfgC8"};